import { UserDto } from "../../../types/dto";
import { getBlast, isMockMode, simulateDelay } from "../../api";

export const getOrg = ({ orgId }: { orgId: string }) => {
	if (isMockMode()) {
		const testData = {
			id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
			name: "Test Name",
			isEnabledShareWithAnon: true,
			isEnabledShareOutsideOrg: false,
		};

		return simulateDelay(50, () => testData) as Promise<{
			results: Array<UserDto>;
		}>;
	}

	return getBlast(`orgs/get?id=${orgId}`) as Promise<{
		results: Array<UserDto>;
	}>;
};
